import moment from 'moment';
import { activityAnalysisListName } from 'src/api/config';
import { addItemRequest } from 'src/modules/spItems/api';

export const setMultiApprove = (groupID: number, approversDependencies: any) => {
    const dependency = approversDependencies.find(
        (item: any) => item.Group?.ID === groupID || item.Group?.get_lookupId?.() === groupID
    );
    return dependency ? dependency.MultiApprove : false;
}

export const checkApprovers = (groupID: number, approversDependencies: any) => {
    return approversDependencies.filter((approveGroup: any) => approveGroup.Group && ((approveGroup.Group.ID && approveGroup.Group.ID === groupID) || (approveGroup.Group.get_lookupId && approveGroup.Group.get_lookupId() === groupID)) && approveGroup.Order0 === 1).length > 0
}

export const addAnalysis = (currentUser: any, documentID: any, documentCode: any, type: string, activeType: string) => {
    const clearStorage: any = localStorage.getItem('Clear');
    const isClear: any = clearStorage && JSON.parse(clearStorage) || { date: moment().clone().startOf('day').unix() };
    if (isClear && moment().unix() > Number(isClear['date'])) {
        localStorage.removeItem('isActive');
        localStorage.removeItem('isVisit');
        localStorage.setItem('Clear', JSON.stringify({ date: moment().clone().add(1, 'd').startOf('day').unix() }));
    }
    if (type === 'isActive' && process.env.NODE_ENV !== "development") {
        const storageActive = localStorage.getItem('isActive');
        const isActive: any = storageActive && JSON.parse(storageActive) || { [currentUser.id]: { [documentID]: { [activeType]: moment().clone().startOf('day').unix() } } };
        if (!isActive[currentUser.id][documentID] || !isActive[currentUser.id][documentID][activeType] || moment().unix() > isActive[currentUser.id][documentID][activeType]) {
            if (isActive[currentUser.id][documentID]) {
                isActive[currentUser.id][documentID][activeType] = moment().clone().add(1, 'd').startOf('day').unix();
            } else {
                isActive[currentUser.id][documentID] = {}
                isActive[currentUser.id][documentID][activeType] = moment().clone().add(1, 'd').startOf('day').unix();
            }
            localStorage.setItem('isActive', JSON.stringify(isActive));
            addItemRequest({ listName: activityAnalysisListName, body: { Title: `Active in ${moment().format('DD.MM.YYYY hh:mm')}`, isActive: true, DocumentCode: documentCode, Document: Number(documentID), AuthorEmail: currentUser.originalEmail, ActiveType: activeType } });
        }
    }
    if (type === 'isVisit' && process.env.NODE_ENV !== "development") {
        const storageVisit = localStorage.getItem('isVisit');
        const isVisit: any = storageVisit && JSON.parse(storageVisit) || { [currentUser.id]: moment().clone().startOf('day').unix() };
        if (isVisit[currentUser.id] && moment().clone().unix() > Number(isVisit[currentUser.id])) {
            isVisit[currentUser.id] = moment().clone().add(1, 'd').startOf('day').unix();
            localStorage.setItem('isVisit', JSON.stringify(isVisit));
            addItemRequest({ listName: activityAnalysisListName, body: { Title: `Visit in ${moment().format('DD.MM.YYYY hh:mm')}`, isVisit: true, AuthorEmail: currentUser.originalEmail } });
        }
    }
}
